import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";
import LatexInput from "./LatexInput"; // ✅ LaTeX input field

function CreateQuestion() {
  const [subject, setSubject] = useState("");
  const [topic, setTopic] = useState("");
  const [type, setType] = useState("multiple-choice");
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [answer, setAnswer] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleOptionChange = (index, value) => {
    const updated = [...options];
    updated[index] = value;
    setOptions(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!subject || !topic || !question || !answer) {
      return setError("⚠️ Please fill in all required fields.");
    }

    if (type === "multiple-choice" && options.some((opt) => opt.trim() === "")) {
      return setError("⚠️ All multiple-choice options must be filled.");
    }

    try {
      await addDoc(collection(db, "questions"), {
        subject,
        topic,
        type,
        question,
        options: type === "multiple-choice" ? options : [],
        answer,
        createdAt: serverTimestamp(),
      });

      // Clear form
      setSubject("");
      setTopic("");
      setType("multiple-choice");
      setQuestion("");
      setOptions(["", "", "", ""]);
      setAnswer("");
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>🧱 Create a New Question</h1>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label>📚 Subject</label>
          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={styles.input}
            required
          >
            <option value="">-- Select --</option>
            <option value="GCSE Maths">GCSE Maths</option>
            <option value="A-Level Maths">A-Level Maths</option>
            <option value="GCSE French">GCSE French</option>
            <option value="A-Level French">A-Level French</option>
          </select>

          <label>📌 Topic</label>
          <input
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="E.g. Algebra"
            style={styles.input}
            required
          />

          <label>📝 Question Type</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            style={styles.input}
          >
            <option value="multiple-choice">Multiple Choice</option>
            <option value="short-answer">Short Answer</option>
          </select>

          <label>❓ Question (LaTeX supported)</label>
          <LatexInput value={question} onChange={setQuestion} height="80px" />

          {type === "multiple-choice" && (
            <>
              <label>🔘 Options (use LaTeX if needed)</label>
              {options.map((opt, i) => (
                <LatexInput
                  key={i}
                  value={opt}
                  onChange={(val) => handleOptionChange(i, val)}
                  height="50px"
                />
              ))}
            </>
          )}

          <label>✅ Correct Answer (LaTeX supported)</label>
          <LatexInput value={answer} onChange={setAnswer} height="60px" />

          <button type="submit" style={styles.button}>
            ➕ Add Question
          </button>

          {success && <p style={{ color: "green" }}>✅ Question added successfully!</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    maxWidth: "700px",
    margin: "0 auto",
    fontFamily: "Poppins, sans-serif",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.6rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
  },
  button: {
    backgroundColor: "#6c63ff",
    color: "white",
    border: "none",
    padding: "0.8rem",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default CreateQuestion;
